module.exports = __webpack_public_path__ + "media/images/logo-australia-0435c179cb016fdc65a719cea0f53d2c.png";